import React, { useState, useEffect } from "react";
import { createFragmentContainer, graphql } from "react-relay";
import "./ContentBox.css";
import SelectionHighlighter from "react-highlight-selection";
import { useTheme } from "../contexts/ThemeContext";

function ContentBox(props) {
	const summary = props.postSummary.summary;
	const [selectedText, setSelectedText] = useState("");
	const theme = useTheme();

	function selectionHandler(selection) {
		console.log(selection);
	}

	// function handleMouseUp(e) {
	// 	e.preventDefault();
	// 	const selectionObj = window.getSelection();
	// 	const text = selectionObj.toString();
	// 	console.log(selectionObj.getRangeAt(0));
	// 	console.log("Selected Text: " + text);
	// }

	return (
		<div className="content-box-container">
			<label> Article Summary: </label>
			{/*
			
			<p>
				<SelectionHighlighter
					text={summary}
					selectionHandler={selectionHandler}
					customClass="custom-class"
				/>
			</p>
			
			*/}
			<p className={`theme-${theme.paragraph}`}> {summary} </p>
		</div>
	);
}

export default createFragmentContainer(ContentBox, {
	postSummary: graphql`
		fragment ContentBox_postSummary on PostSummaryNode {
			summary
		}
	`
});
